import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/lib/auth-context'
import { AdminLayout } from '@/components/admin-layout'

export const Route = createFileRoute('/_admin')({
  component: AdminLayoutRoute,
})

function AdminLayoutRoute() {
  const { user, loading, isPlatformAdmin } = useAuth()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  if (!isPlatformAdmin) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">Zugriff verweigert</h1>
          <p className="text-muted-foreground mt-2">
            Du benötigst Platform-Admin Rechte.
          </p>
        </div>
      </div>
    )
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  )
}
